import { render, staticRenderFns } from "./schemeUserDetails.vue?vue&type=template&id=06a1a028&scoped=true&"
import script from "./schemeUserDetails.vue?vue&type=script&lang=js&"
export * from "./schemeUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1a028",
  null
  
)

component.options.__file = "schemeUserDetails.vue"
export default component.exports